<template>

    <CRow>
        <CCol>
            <CCard>
                <CCardBody>
                    <CRow class="pl-3 pb-3" />
                    
                    <CRow class="pb-3">
                        <CCol sm="12">
                            <CButton color="primary" @click="create">Создать</CButton>
                        </CCol>
                    </CRow>                    
                    <CRow class="pl-3">
                        <table class="table">
                            <thead>
                                <th></th>
                                <th>Вопрос</th>
                                <th>Ответ</th>
                                <th></th>
                            </thead>
                            <draggable v-model="list" tag="tbody">
                                <tr v-for="fq in list" :key="fq.title">
                                    <td><CIcon
                                        :height="24"
                                        :content="$options.icons.cilCursorMove"
                                        class="handle" /></td>
                                    <td>{{ fq.title }}</td>
                                    <td>{{ fq.description }}</td>
                                    <td>
                                        <CButton @click="edit(fq.id)"><CIcon :content="$options.icons.cilPencil" class="handle" /></CButton>
                                        <CButton @click="removeConfirmation(fq.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            :title="createEditModalTitle"
            :show.sync="createEditModal.visible"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Вопрос</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.faq.title"
                                    placeholder="Заголовок"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Ответ</CCol>
                            <CCol sm="9">
                                <CTextarea
                                    v-model="createEditModal.faq.description"
                                    placeholder="Описание"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="createEditModal.visible = false">Отмена</CButton>
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="createUpdateFAQ">{{ createEditModalButton }}</CButton>
                </div>
            </template>
        </CModal>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal.visible"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>Вы действительно хотите удалить "вопрос"? Это действие нельзя будет отменить.</p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal.visible = false">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="remove">Удалить</CButton>
                </div>
            </template>
        </CModal>


    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash, cilPencil } from '@coreui/icons';

    export default {

        name: 'FaqSettings',

        components: {
            draggable,
        },
  
        data () {
            return {
                list: [],
                createEditModal: {
                    visible: false,
                    editMode: false,
                    editId:0,
                    faq: {
                        title: '',
                        description: '',
                        position: 0
                    }
                },
                deleteModal: {
                    visible: false,
                    faqId: 0
                },
            }
        },
    
        computed: {
            createEditModalTitle: function() {
                return this.createEditModal.editMode ? 'Редактирование вопроса' : 'Создание вопроса';
            },
            createEditModalButton: function() {
                return this.createEditModal.editMode ? 'Сохранить' : 'Создать';
            }
        },

        mounted() {
            Vue.axios.get('/faq')
                .then(resp => {
                    this.list = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        icons: {
            cilCursorMove,
            cilTrash,
            cilPencil
        },

        methods: {

            create() {
                this.createEditModal.editMode = false;
                this.createEditModal.faq.title = '',
                this.createEditModal.faq.description = '';
                this.createEditModal.visible = true; 
            },

            createUpdateFAQ() {
                if(!this.createEditModal.faq.title) {
                    this.$root.$emit('showError', 'Заголовок является обязательным.');
                    return;
                }
                if(!this.createEditModal.faq.description) {
                    this.$root.$emit('showError', 'Описание является обязательным.');
                    return;
                }
                if(this.createEditModal.editMode) {
                    Vue.axios.put('/faq/' + this.createEditModal.editId , this.createEditModal.faq)
                        .then(resp => {
                            const justUpdated = resp.data;
                            const _list = this.list.slice();
                            for(var i = 0; i < _list.length; i++) {
                                if(_list[i].id === justUpdated.id) {
                                    _list[i] = justUpdated;
                                }
                            }
                            this.list = _list;
                            this.createEditModal.visible = false;
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка сохранения.');
                        });
                } else {
                    Vue.axios.post('/faq', this.createEditModal.faq)
                        .then(resp => {
                            const justCreated = resp.data;
                            const _list = this.list.slice();
                            _list.push(justCreated);
                            this.list = _list;
                            this.createEditModal.visible = false;
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка сохранения.');
                        });
                }
            },

            edit(id) {
                this.createEditModal.editId = id;
                this.createEditModal.editMode = true;
            
                var _list = {};
                for(var i = 0; i < this.list.length; i++) {
                    if(this.list[i].id === id) {
                        _list = this.list[i];
                    }
                }

                this.createEditModal.faq.title = _list.title,
                this.createEditModal.faq.description = _list.description;
                this.createEditModal.faq.position = _list.position;
            
                this.createEditModal.visible = true;
            },

            save() {
                // Save order only
                const reorder = [];
                let index = 0;
                this.list.forEach(fq => {
                    reorder.push({
                        id: fq.id,
                        position: ++index
                    });
                });
                Vue.axios.post('/faq/reorder', { reorder: reorder })
                    .then(resp => {
                        this.$router.go(0)
                    })
                    .catch(err => {
                        console.log(err, 'err');
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            removeConfirmation(id) {
                this.deleteModal.faqId = id;
                this.deleteModal.visible = true;
            },

            remove() {
                const id = this.deleteModal.faqId;
                Vue.axios.delete('/faq/' + id)
                    .then(resp => {
                        const _list = [];
                        for(var i = 0; i < this.list.length; i++) {
                            if(id != this.list[i].id) {
                                _list.push(this.list[i]);
                            }
                        }
                        this.list = _list;
                        this.deleteModal.visible = false;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            goBack() {
                this.$router.push({ path: '/' })
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
        }
    }

</script>
<style scoped>
.handle {
  cursor: pointer;
}
</style>